// extracted by mini-css-extract-plugin
module.exports =  {"newMenu":"newMenu_yN1KLKTn","uiNewMenuItem":"uiNewMenuItem_yMuf8Uz8"};